import React from 'react'
import { useEpg, Layout, Epg } from 'planby'
import { object, string } from 'prop-types'
import styles from './EventAgenda.module.scss'
import Type from '@/component/Primitive/Type'
import Container from '@/component/Primitive/Container'
import Stack from '@/component/Primitive/Stack'
import { Highlight } from '@/component/Primitive/Events'
import { ProgramItem } from './components'
import moment from 'moment'

export const EventAgenda = ({ event, backgroundImage }) => {
  const { agenda, startDate, endDate } = event

  const channels = event.locations.map((l) => ({
    uuid: l.name,
    name: l.name
  }))

  const epg = agenda.map((item, i) => ({
    channelUuid: item.location.name,
    id: item.name,
    realSince: item.startDate,
    realTill: item.endDate,
    since: moment(item.startDate).add(30, 'minutes').toISOString(), // Add 30 minutes to startDate - BUG
    till: moment(item.endDate).add(30, 'minutes').toISOString(), // Add 30 minutes to endDate - BUG
    name: item.name,
    speakers: item.speakers || [],
    sessionType: item.sessionType.name,
    description: item.description,
    location: item.location.name,
    tags: item.tags
  }))

  const sortedAgenda = agenda.sort((a, b) => {
    return new Date(a.startDate) - new Date(b.startDate)
  })

  const getStartDate = (date) => new Date(date.setMinutes(0, 0, 0))

  const { getEpgProps, getLayoutProps } = useEpg({
    channels,
    epg,
    startDate: getStartDate(new Date(sortedAgenda[0].startDate)).toISOString()
    // dayWidth: 2000,
    // sidebarWidth: 100,
    // itemHeight: 80,
    // height: 260,
    // isSidebar: true,
    // isTimeline: true,
    // theme,
    // planbyGlobalStyles
  })

  const formattedStartDate = moment(startDate).format('dddd Do MMMM')
  const formattedEndDate = moment(endDate).format('dddd Do MMMM')
  const dateRange = `📅 ${formattedStartDate} - ${formattedEndDate}`

  return (
    <div className={styles.EventAgenda}>
      {backgroundImage && (
        <div
          className={styles.EventAgendaImage}
          style={{ backgroundImage: `url(${backgroundImage})` }}
        />
      )}
      <Container className={styles.Container} center gutter size="wide">
        <Stack>
          <Stack gap="small">
            <Type
              as="h1"
              size={['heading5', 'heading2']}
              weight="extrabold"
              className={styles.Title}
            >
              <Highlight>{`<p>Event <strong>Agenda</strong></p>`}</Highlight>
            </Type>
            <Type
              as="h2"
              size={['body2', 'body3']}
              weight="medium"
              className={styles.Subtitle}
            >
              {dateRange}
            </Type>
          </Stack>
          <div style={{ width: '100%' }} className={styles.EpgWrapper}>
            <Epg isLoading={false} width="100%" {...getEpgProps()}>
              <Layout
                {...getLayoutProps()}
                renderChannel={({ channel }) => <ChannelItem {...channel} />}
                // renderTimeline={(props) => (
                //   <Timeline
                //     {...props}
                //     startDate={startDate}
                //     endDate={endDate}
                //     ref={getLayoutProps().ref}
                //   />
                // )}
                renderProgram={(props) => <ProgramItem {...props} />}
              />
            </Epg>
          </div>
        </Stack>
      </Container>
    </div>
  )
}

EventAgenda.propTypes = {
  event: object,
  startDate: string,
  backgroundImage: object
}

const ChannelItem = ({ name }) => {
  return (
    <Type size="body3" className={styles.ChannelItem}>
      <p className={styles.Text}>{name}</p>
    </Type>
  )
}

ChannelItem.propTypes = {
  name: string
}
